import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    buttonLabel: string;
    buttonLabelWithCount: (count: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the Upload Links link in the ProjectTree */
            buttonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectTreeUploadLinks.buttonLabel?c=3iprdkei1mhyi", defaultMessage: "Upload Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the Upload Links link with a count of links in the project */
            buttonLabelWithCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "ProjectTreeUploadLinks.buttonLabelWithCount?c=1dkpoq0ent3x0", defaultMessage: "Upload Links ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
